import React, { useState, useEffect } from "react";
import { Typography, Stack, Box, Divider, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Link, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
// src
import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";
import StudentInformation from "./StudentInformation";
import StudentEnrollment from "./StudentEnrollment/StudentEnrollment";
import StudentAttendance from "./StudentAttendance/StudentAttendance";
import { GET_STUDENT_BY_ID } from "../../../Schema/Student";

export default function StudentDetail() {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  // ===== tab ==========================
  const [tabVal, setTabVal] = useState("tab-info");
  useEffect(() => {
    let getTabStudent = JSON.parse(window.localStorage.getItem("tabStudent"));
    if (getTabStudent) {
      setTabVal(getTabStudent);
    }
  }, []);

  // =====================
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let stuId = params.get("id");

  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_STUDENT_BY_ID, {
    variables: {
      id: stuId,
    },
    onCompleted: ({ getStudentById }) => {
      setTableData(getStudentById);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [stuId]);

  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/student">
              <Typography
                className={language === "kh" ? "page-title-kh" : "page-title"}
              >
                {t(`page-student`)}
              </Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="slash-title">/</Typography>
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {language === "en"
                ? tableData?.full_name_latin
                : tableData?.full_name_kh}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>
      <Box sx={{ marginTop: "15px" }}>
        <Grid container spacing={3} className="tab-btn-celendar">
          <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
            <Button
              fullWidth
              onClick={() => {
                setTabVal("tab-info");
                window.localStorage.setItem(
                  "tabStudent",
                  JSON.stringify("tab-info")
                );
              }}
              className={tabVal === "tab-info" ? "active-btn" : "in-active-btn"}
            >
              {t("information")}
            </Button>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
            <Button
              fullWidth
              onClick={() => {
                setTabVal("tab-att");
                window.localStorage.setItem(
                  "tabStudent",
                  JSON.stringify("tab-att")
                );
              }}
              className={tabVal === "tab-att" ? "active-btn" : "in-active-btn"}
            >
              {t("attendance")}
            </Button>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
            <Button
              fullWidth
              onClick={() => {
                setTabVal("tab-enroll");
                window.localStorage.setItem(
                  "tabStudent",
                  JSON.stringify("tab-enroll")
                );
              }}
              className={
                tabVal === "tab-enroll" ? "active-btn" : "in-active-btn"
              }
            >
              {t("enrollment")}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ marginTop: "30px" }}>
        {tabVal === "tab-info" ? (
          <StudentInformation tableData={tableData} />
        ) : null}
        {tabVal === "tab-enroll" ? <StudentEnrollment /> : null}
        {tabVal === "tab-att" ? (
          <StudentAttendance editData={tableData} stuId={stuId} />
        ) : null}
      </Box>
    </div>
  );
}
